export const DEFAULT_CSV_DELIMITER = ";";

export const DISCLAIMER_MODAL_KEYS = {
  BATCH: "hideBatchDisclaimerModal",
  MATERIAL_CHANGE: "hideMaterialSelectDisclaimerModal",
} as const;
